import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { StakeError } from '../stake-error';

export class OverMaximumStake extends StakeError {
    constructor(hasClientValidation?: boolean) {
        super();
        this.icon = BetPlacementErrorIcon.Warning;
        this.type = PlacementErrorType.OverMaxBetLimit;

        if (typeof hasClientValidation !== 'undefined') {
            this.hasClientValidation = hasClientValidation;
        }
    }
}
